import { Context } from '@nuxt/types'
import createPersistedState from 'vuex-persistedstate'
import { appName } from '~~/config'
import { SUB_ACCOUNT_KEYS } from '~/store/subAccount'

export const VuexPersistedStateKey = appName + 'v3'

export default ({ store }: Context) => {
  createPersistedState({
    key: VuexPersistedStateKey,
    paths: [
      'common.version',
      'common.language',
      'common.config',
      'common.tokens',
      SUB_ACCOUNT_KEYS.namespace,
      'me.inviter',
      'me.channel',
      'me.reverseRecord'
    ]
  })(store)
}
